import React from 'react';
import OpenCloseButton from '../../../ui/OpenCloseButton';
import styles from './slideshowTeaser.module.scss';

const SlideshowTeaser = props => {
  const { title, images, body, setActiveDetail, isActive } = props;
  const { url, alt } = images[0];
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <div className={styles.imageContainerInner}>
          <img className={styles.image} src={images[0].sizes.large} alt={alt} />
          <div
            className={!isActive ? styles.buttonWrap : styles.buttonWrapClosed}
          >
            <OpenCloseButton
              clicked={isActive}
              onClick={setActiveDetail.bind(null, props)}
            />
          </div>
        </div>
      </div>
      <div className={styles.contentContainer}>
        {title.length && (
          <h4
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {body.legnth && (
          <p
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        )}
      </div>
    </div>
  );
};

export default SlideshowTeaser;



// WEBPACK FOOTER //
// ./src/components/tour/details/teasers/SlideshowTeaser.js